const defaultUrl = 'https://easy-mock.com/mock/5d5f95aaeb47633759eabb92/example/mock?accounttraceid=bac96013-2b51-4a53-8dd4-a7ddfe15d274&spm=datav.10712463.0.0.27b73967MPuRnq';
import axios from 'axios';
export const fetchPointData = async (url?: string, option?: any) => {
	return await new Promise( (resolve, reject) => {
		axios.get(defaultUrl)
		.then( (response) => {
			resolve(response.data.data);
		})
		.catch( (error) => {
			console.log(error);
			reject(reject);
		});
	});
}